// extracted by mini-css-extract-plugin
export var aboveInput = "_j3-0";
export var actionButton = "_j3-5";
export var actionButtonContainer = "_j3-1";
export var actionIcon = "_j3-6";
export var aiInfoContainer = "_j3-2";
export var attachmentWrapper = "_j3-7";
export var bold = "_j3-3";
export var checkIcon = "_j3-8";
export var clickingRecipientBar = "_j3-11";
export var commentThreadSwitch = "_j3-a";
export var draftImage = "_j3-b";
export var draftImageContainer = "_j3-c";
export var draftImages = "_j3-e";
export var editButton = "_j3-g";
export var editor = "_j3-f";
export var editorContainer = "_j3-y";
export var editorErrorTooltipWrapper = "_j3-9";
export var headerDivider = "_j3-h";
export var icon = "_j3-i";
export var info = "_j3-j";
export var internal = "_j3-n";
export var internalDivider = "_j3-k";
export var internalMessage = "_j3-l";
export var messageInputCard = "_j3-m";
export var messageInputForm = "_j3-o";
export var messageInputFormInternal = "_j3-p";
export var options = "_j3-q";
export var publicMessageCustomer = "_j3-s";
export var publicMessageMerchant = "_j3-r";
export var removeImageButton = "_j3-d";
export var replyButtons = "_j3-t";
export var showSignatureButton = "_j3-u";
export var spinner = "_j3-v";
export var verticalButtonDivider = "_j3-4";
export var visibilitySelector = "_j3-w";
export var warning = "_j3-x";
export var wrappingText = "_j3-z";
export var writingInternalNoteTopBorder = "_j3-10";